import React from 'react';

import ArrowBack from '@mui/icons-material/ArrowBackRounded';
import { IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { Lead } from '../../../services/leads/types';
import { TopButtonsContainer } from '../index.styles';

interface TopBarProps {
  lead?: Lead,
}

const TopBar = ({ lead }: TopBarProps) => {
  const navigate = useNavigate();

  return (
    <TopButtonsContainer>
      <IconButton onClick={() => navigate(-1)}>
        <ArrowBack />
      </IconButton>
      <Typography variant="h5">
        {lead?.name}
      </Typography>
      <div />
    </TopButtonsContainer>
  );
};

export default TopBar;
